
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/board-results",
      function () {
        return require("private-next-pages/education/board-results/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/board-results"])
      });
    }
  